var Backbone = require('backbone');

export default Backbone.View.extend({

  className: 'message',

  initialize: function(options) {
    this.message = options.message || '';
  },

  render: function() {
    this.$el.text(this.message);
    return this;
  },

});
